import { Operation } from 'fast-json-patch';

export function itemFileSetPrimaryPatchOperations(): Operation[] {
    return [{ op: 'replace', path: '/isDefault', value: true }];
}
